import { posts } from '../content/site';

export function BlogPage() {
  return (
    <div className="site-container page">
      <section className="page-intro">
        <p className="page-intro__label">Blog</p>
        <h1>Things I’m writing through.</h1>
        <p>Essays, book reviews, reflections on Jewish thought, public life, work, and whatever else I am trying to understand.</p>
      </section>

      {posts.length === 0 ? (
        <div className="empty-state">
          <p>The archive is empty for now. The first posts will appear here as they are written.</p>
        </div>
      ) : null}
    </div>
  );
}
